export default __webpack_public_path__ + "static/media/single-project-page-03-img16.44b4ecd3.jpg";